


























import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class TheThgProcessingList extends Vue {
  ActionEnum = ActionEnum;
  ResourceEnum = ResourceEnum;

  get items() {
    return [
      {
        icon: "mdi-note-search-outline",
        text: "Workitems",
        link: "/thgworkitems"
      }
    ];
  }

  get adminItems() {
    return [
      {
        icon: "mdi-numeric-9-plus-box-multiple-outline",
        text: "Batch",
        link: "/batch"
      },
      {
        icon: "mdi-file-cog-outline",
        text: "navigation.ThePartnerList.setting.operations",
        link: "/operation"
      },
      {
        icon: "mdi-cash-multiple",
        text: "navigation.ThePartnerList.setting.billingList",
        link: "/billing/list"
      },
      {
        icon: "mdi-cash",
        text: "navigation.ThePartnerList.setting.billing",
        link: "/billingcreation/"
      },
      {
        icon: "mdi-bank-outline",
        text: "navigation.ThePartnerList.setting.accounting",
        link: "/billing/accounting"
      },
      {
        icon: "mdi-credit-card-multiple-outline",
        text: "navigation.ThePartnerList.setting.creditor",
        link: "/billing/creditor"
      }
    ];
  }
}
